<div class="full-width full-height" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
  <app-yarn-type-grid-preview fxFlex="1 0 calc(100% - 24px)" [yarnTypes]="yarnTypes" [tooltipDisabled]="true"> </app-yarn-type-grid-preview>
  <span class="position" *ngIf="isCreelPositionDifferentFromTheoreticalCreel">({{ position }})</span>
</div>
